// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Status } from "./status";

export class NormalStatus implements flatbuffers.IUnpackableObject<NormalStatusT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): NormalStatus {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsNormalStatus(bb: flatbuffers.ByteBuffer, obj?: NormalStatus): NormalStatus {
    return (obj || new NormalStatus()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsNormalStatus(
    bb: flatbuffers.ByteBuffer,
    obj?: NormalStatus,
  ): NormalStatus {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new NormalStatus()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  message(): Status {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : Status.HighSpeedStartSequence;
  }

  static startNormalStatus(builder: flatbuffers.Builder) {
    builder.startObject(1);
  }

  static addMessage(builder: flatbuffers.Builder, message: Status) {
    builder.addFieldInt16(0, message, Status.HighSpeedStartSequence);
  }

  static endNormalStatus(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createNormalStatus(builder: flatbuffers.Builder, message: Status): flatbuffers.Offset {
    NormalStatus.startNormalStatus(builder);
    NormalStatus.addMessage(builder, message);
    return NormalStatus.endNormalStatus(builder);
  }

  unpack(): NormalStatusT {
    return new NormalStatusT(this.message());
  }

  unpackTo(_o: NormalStatusT): void {
    _o.message = this.message();
  }

  unpackFields(...fields: string[]): NormalStatusT {
    const t = new NormalStatusT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message")) {
      t.message = this.message();
    }
    return t;
  }
}

export class NormalStatusT implements flatbuffers.IGeneratedObject {
  constructor(public message: Status = Status.HighSpeedStartSequence) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return NormalStatus.createNormalStatus(builder, this.message);
  }

  clone(): NormalStatusT {
    const obj = new NormalStatusT();
    obj.message = this.message;
    return obj;
  }

  equals(other: NormalStatusT): boolean {
    if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyNormalStatus(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 2);
  } finally {
    verifier.popDepth();
  }
}
